import {all,call} from 'redux-saga/effects';

import { trainSaga } from './train/train.saga';


export default function* rootSaga(){
    yield all([
        call(trainSaga),
    ]);
}